import React from 'react';
import { MentorAreaConfig } from '../../types/mentorship';
import { CreditCard, FileText, Sparkles } from 'lucide-react';

interface MentorshipHubPageProps {
  mentorships: MentorAreaConfig[];
  onSelectMentorship: (slug: string) => void;
  userName?: string;
}

export const MentorshipHubPage: React.FC<MentorshipHubPageProps> = ({
  mentorships,
  onSelectMentorship,
  userName = 'Vitor',
}) => {
  return (
    <div className="w-full min-h-screen bg-[#121316] text-white p-4 md:p-10 flex flex-col gap-10 animate-fade-in select-none">
      {/* Top Welcome Bar & Action Buttons (Hubla Image 1) */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 pb-6 border-b border-white/10">
        <div>
          <h1 className="text-3xl md:text-4xl font-black text-white tracking-tight">
            Olá, {userName}
          </h1>
        </div>

        {/* Subscriptions & Invoices buttons */}
        <div className="flex items-center gap-3">
          <button className="flex items-center gap-2 px-4 py-2 rounded-xl bg-[#1c1e24] hover:bg-white/10 border border-white/10 text-xs font-semibold text-gray-200 transition-all active:scale-95">
            <FileText className="w-4 h-4 text-gray-400" />
            <span>Histórico de faturas</span>
          </button>

          <button className="flex items-center gap-2 px-4 py-2 rounded-xl bg-[#1c1e24] hover:bg-white/10 border border-white/10 text-xs font-semibold text-gray-200 transition-all active:scale-95">
            <CreditCard className="w-4 h-4 text-[#0FFF55]" />
            <span>Minhas assinaturas</span>
          </button>
        </div>
      </div>

      {/* Grid de Mentorias (Hubla Image 1 Card Style) */}
      <div className="flex flex-col gap-6">
        <div className="flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-[#0FFF55]" />
          <h2 className="text-base font-bold text-gray-300 uppercase tracking-wider">
            Meus Cursos
          </h2>
        </div>

        <div className="flex flex-wrap gap-8">
          {mentorships.map((item) => (
            <div
              key={item.id}
              onClick={() => onSelectMentorship(item.slug)}
              className="group flex flex-col items-center gap-3 cursor-pointer select-none"
            >
              {/* Card Thumbnail (Rounded Rectangle matching Hubla Screenshot 1) */}
              <div className="relative w-64 h-40 rounded-3xl overflow-hidden bg-black border border-white/10 hover:border-[#0FFF55]/60 transition-all duration-300 transform group-hover:scale-105 shadow-2xl">
                <img
                  src={item.branding.coverImageUrl}
                  alt={item.courseTitle}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-out"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              </div>

              {/* Title below Card */}
              <span className="text-xs font-bold text-gray-200 group-hover:text-[#0FFF55] transition-colors">
                {item.courseTitle}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
